<template>
  <div class="home-main">
    <HomeHerder></HomeHerder>
    <!-- 第一屏 -->
    <div class="home-page1">
      <div class="left">
        <div :class="['blod', { 'blod-en': $i18n.locale === 'en' }]">
          {{ $t("home.page1.title1") }}
        </div>
        <div :class="['blod', { 'blod-en': $i18n.locale === 'en' }]">
          {{ $t("home.page1.title2") }}
        </div>
        <div class="tips">
          {{ $t("home.page1.title3") }}
        </div>
        <div
          @click="goUrl('/module/help')"
          :class="['more', { 'more-en': $i18n.locale === 'en' }]"
        >
          <img class="arrow-right" src="@/assets/image/home/arrow-right.png" />
          <span>{{ $t("home.page1.title4") }}</span>
        </div>
      </div>
      <div class="right">
        <div class="img-box">
          <div class="iocn-box gold">
            <img src="@/assets/image/home/gold.png" />
          </div>
          <div class="iocn-box mail">
            <img src="@/assets/image/home/mail.png" />
          </div>
          <div class="iocn-box paper_airplane">
            <img src="@/assets/image/home/paper_airplane.png" />
          </div>
          <div class="iocn-box search">
            <img src="@/assets/image/home/search.png" />
          </div>
          <div class="iocn-box light">
            <img src="@/assets/image/home/light.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 第二屏 -->
    <div class="home-page2">
      <div class="title-box">
        <div class="blod">{{ $t("home.page2.title1") }}</div>
        <div class="line-box">
          <div class="line-one"></div>
          <div class="line-tow"></div>
        </div>
        <div class="tips">
          <img
            class="text-border"
            src="@/assets/image/home/text-border.png"
          />{{ $t("home.page2.tips1") }}
          <img class="text-border" src="@/assets/image/home/text-border.png" />
        </div>
      </div>

      <div class="step-boxs">
        <div class="step-box">
          <div class="step-title">
            <div class="number number1">01</div>
          </div>
          <div class="step-text">
            <div class="bold">{{ $t("home.page2.boxs1.title1") }}</div>
            <div class="tips">{{ $t("home.page2.boxs1.title2") }}</div>
          </div>
        </div>
        <div class="step-box">
          <div class="step-title">
            <div class="number number2">02</div>
          </div>
          <div class="step-text">
            <div class="bold">{{ $t("home.page2.boxs2.title1") }}</div>
            <div class="tips">{{ $t("home.page2.boxs2.title2") }}</div>
          </div>
        </div>
        <div class="step-box">
          <div class="step-title">
            <div class="number number3">03</div>
          </div>
          <div class="step-text">
            <div class="bold">{{ $t("home.page2.boxs3.title1") }}</div>
            <div class="tips">{{ $t("home.page2.boxs3.title2") }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 第三屏 -->
    <div class="home-page3">
      <div class="left">
        <img class="circle" src="@/assets/image/home/page3-1.png" />
        <img class="article" src="@/assets/image/home/page3-2.png" />
        <img class="card" src="@/assets/image/home/page3-3.png" />
        <div class="ball">
          <img class="search" src="@/assets/image/home/page3-4.png" />
        </div>
      </div>
      <div class="right">
        <div class="blod">我是标题我是标题</div>
        <div class="tips">
          我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容
          我是内容我是内容我是内容我是内容我是内容我是内容
          我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是
          我是内容我是内容我是内容我是内容
        </div>
      </div>
    </div>
    <!-- 第四屏 -->
    <div class="home-page4">
      <div class="left">
        <div class="title">我是标题我是标题</div>
        <div class="tips">
          我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容
          我是内容我是内容我是内容我是内容我是内容我是内容
          我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是
          我是内容我是内容我是内容我是内容
          我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是
          我是内容我是内容我是内容我是内容
        </div>
      </div>
      <div class="right">
        <img src="@/assets/image/home/page4.png" />
      </div>
    </div>
    <!-- 第五屏 -->
    <div class="home-page5">
      <div class="title-box">
        <div class="blod">{{ $t("home.page5.title1") }}</div>
        <div class="line-box">
          <div class="line-one"></div>
          <div class="line-tow"></div>
        </div>
        <div class="tips">
          <img
            class="text-border"
            src="@/assets/image/home/text-border.png"
          />{{ $t("home.page5.tips1") }}
          <img class="text-border" src="@/assets/image/home/text-border.png" />
        </div>
      </div>
      <div class="number-boxs">
        <div class="number-box">
          <div class="number number1">
            <animate-number from="0" to="97000"></animate-number>
            <span>+</span>
          </div>
          <div class="text">{{ $t("home.page5.boxs1") }}</div>
        </div>
        <div class="number-box">
          <div class="number number2">
            <animate-number from="0" to="97000"></animate-number>
            <span>+</span>
          </div>
          <div class="text">{{ $t("home.page5.boxs2") }}</div>
        </div>
        <div class="number-box">
          <div class="number number3">
            <animate-number from="0" to="55000"></animate-number>
            <span>w+</span>
          </div>
          <div class="text">{{ $t("home.page5.boxs3") }}</div>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <div class="footer-box">
      <div class="search-box">
        <div class="text-box">{{ $t("home.footer.title1") }}</div>
        <div class="btn-box">{{ $t("home.footer.title2") }}</div>
      </div>

      <div class="content-box">
        <div class="icon-box" @click="goUrl('/')">
          <img src="@/assets/image/common/logo-white.png" />
        </div>
        <div class="line"></div>
        <div class="info-boxs">
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title3") }}</div>
            <div class="tips">
              我是内容我是内容我是内容 我是内容我是内容我是内容 我是内容我是内容
            </div>
          </div>
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title4") }}</div>

            <div class="item-box">
              <div class="item">{{ $t("home.footer.title5") }}</div>
              <div class="item">{{ $t("home.footer.title6") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title7") }}</div>
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title8") }}</div>
              <div class="item">{{ $t("home.footer.title9") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title10") }}</div>
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title11") }}</div>
              <div class="item">{{ $t("home.footer.title12") }}</div>
              <div class="item">{{ $t("home.footer.title13") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="herder">
              <img src="@/assets/image/home/mail2.png" />
              <span>1234567890@163.com</span>
            </div>
            <div class="code-box">
              <img src="@/assets/image/home/code.jpg" />
              <div>{{ $t("home.footer.title14") }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="filing">
        Copyright © 2023 All Rights Reserved.版权所有
        江北新区研科计算机系统服务中心 苏ICP备123456789号-1
      </div>
    </div>

    <!-- 页脚移动端 -->
    <div class="footer-box2">
      <div class="content-box">
        <div class="icon-box" @click="goUrl('/')">
          <img src="@/assets/image/common/logo-white.png" />
        </div>
        <div class="line"></div>
        <div class="info-boxs">
          <div class="info-box">
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title5") }}</div>
              <div class="item">{{ $t("home.footer.title8") }}</div>
              <div class="item">{{ $t("home.footer.title9") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title13") }}</div>
              <div class="item">{{ $t("home.footer.title11") }}</div>
              <div class="item">{{ $t("home.footer.title12") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title15") }}</div>
              <div class="herder">
                <img src="@/assets/image/home/mail2.png" />
                <span>1234567890@163.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filing">
        <div>Copyright © 2023 All Rights Reserved.</div>
        <div>版权所有 江北新区研科计算机系统服务中心</div>
        <div>苏ICP备123456789号-1</div>
      </div>
    </div>
  </div>
</template>
<script>
import HomeHerder from "@/components/Herder/homeHerder.vue";
export default {
  data() {
    return {};
  },
  components: {
    HomeHerder,
  },
  methods: {
    goLogin() {
      this.$router.push("/login");
    },

        //跳转
    goUrl(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style lang="scss" scoped>
.home-main {
  width: 100%;
  // 第一屏
  .home-page1 {
    width: 100%;
    min-height: 800px;
    // height: 100vh;
    background-image: url("../assets/image/home/bg1.png");
    background-size: cover;
    background-position: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    .left {
      margin-left: 140px;
      width: 450px;
      flex-shrink: 0;
      .blod {
        font-size: 59px;
        font-weight: bolder;
        margin-bottom: 11px;
      }
      .blod-en {
        font-size: 35px;
      }
      .tips {
        font-size: 14px;
        margin-top: 48px;
        margin-bottom: 84px;
        line-height: 28px;
      }
      .more {
        width: 187px;
        height: 52px;
        border-radius: 26px;
        background-color: #fff;
        display: flex;
        align-items: center;
        letter-spacing: 1px;
        color: #4776e6;
        cursor: pointer;
        .arrow-right {
          width: 45px;
          height: 45px;
          font-size: 18px;
          margin-left: 4px;
          margin-right: 31px;
        }
      }
      .more-en {
        .arrow-right {
          margin-right: 20px;
        }
      }
    }
    .right {
      flex-shrink: 0;
      width: 568px;
      height: 428px;
      margin-right: 140px;
      .img-box {
        position: relative;
        width: 568px;
        height: 428px;
        background-image: url("../assets/image/home/bg2.png");
        background-size: 100% 100%;
        // background-position: 100% 100%;
        .iocn-box {
          position: absolute;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .gold {
          left: 427px;
          top: 20px;
          width: 44px;
          height: 44px;
          animation: gold-down 5s linear infinite;
        }
        .mail {
          left: 131px;
          top: 2px;
          width: 60px;
          height: 60px;
          animation: mail-ver 3s linear infinite;
        }
        .paper_airplane {
          right: -44px;
          top: -105px;
          width: 253px;
          height: 105px;
          animation: paper-airplane 6s linear infinite;
        }
        .search {
          right: -40px;
          top: 89px;
          width: 75px;
          height: 87px;
          animation: search 8s linear infinite;
        }
        .light {
          width: 44px;
          height: 44px;
          left: -40px;
          top: -40px;
          animation: light 2s linear infinite;
        }
      }
    }
  }
  // 第二屏
  .home-page2 {
    width: 100%;
    margin-top: 13px;
    .title-box {
      width: 572px;
      height: 352px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      background-image: url("../assets/image/home/bg3.png");
      background-size: 100% 100%;
      padding-top: 86px;
      box-sizing: border-box;
      .blod {
        text-align: center;
        font-size: 38px;
        font-weight: bolder;
      }
      .line-box {
        display: flex;
        justify-content: center;
        margin-top: 25px;
        .line-one {
          width: 49px;
          height: 8px;
          background: #8e54e9;
          border-radius: 5px 5px 5px 5px;
        }
        .line-tow {
          width: 14px;
          height: 8px;
          background: #8e54e9;
          border-radius: 5px 5px 5px 5px;
          margin-left: 5px;
        }
      }
      .tips {
        text-align: center;
        font-size: 16px;
        color: #000000;
        margin-top: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        .text-border {
          width: 35px;
          height: 10px;
          margin: 0 10px;
        }
      }
    }
    .step-boxs {
      display: flex;
      justify-content: center;
      .step-box {
        width: 278px;
        margin: 0 80px;
        .step-title {
          width: 278px;
          height: 184px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          .number {
            font-size: 64px;
            font-weight: bolder;
            color: #fff;
          }
          .number1::before {
            position: absolute;
            left: 62.5px;
            top: 23px;
            width: 153px;
            height: 138px;
            background-image: url("../assets/image/home/number1.png");
            background-position-x: 0%;
            background-position-y: 0%;
            background-repeat: repeat;
            background-size: auto;
            content: "";
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            z-index: -1;
            transition: 0.5s;
          }
          .number1::after {
            position: absolute;
            content: "";
            top: 80px;
            right: -192px;
            height: 50px;
            width: 234px;
            background-image: url("../assets/image/home/number-line1.png");
            background-position-x: 0%;
            background-position-y: 0%;
            background-repeat: repeat;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
          }
          .number2::before {
            position: absolute;
            left: 62.5px;
            top: 23px;
            width: 153px;
            height: 138px;
            background-image: url("../assets/image/home/number2.png");
            background-position-x: 0%;
            background-position-y: 0%;
            background-repeat: repeat;
            background-size: auto;
            content: "";
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            z-index: -1;
            transition: 0.5s;
          }
          .number2::after {
            position: absolute;
            content: "";
            top: 60px;
            right: -200px;
            height: 50px;
            width: 234px;
            background-image: url("../assets/image/home/number-line2.png");
            background-position-x: 0%;
            background-position-y: 0%;
            background-repeat: repeat;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
          }
          .number3::before {
            position: absolute;
            left: 62.5px;
            top: 23px;
            width: 153px;
            height: 138px;
            background-image: url("../assets/image/home/number3.png");
            background-position-x: 0%;
            background-position-y: 0%;
            background-repeat: repeat;
            background-size: auto;
            content: "";
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            z-index: -1;
            transition: 0.5s;
          }
        }
        .step-title:hover {
          .number::before {
            transform: rotate(45deg);
          }
        }
        .step-text {
          margin-top: 49px;
          .bold {
            text-align: center;
            font-size: 24px;
            color: #000;
            font-weight: bolder;
          }
          .tips {
            width: 100%;
            text-align: center;
            font-size: 16px;
            color: #000;
            margin-top: 24px;
          }
        }
      }
      .step-box:first-child {
        margin-left: 0;
      }
      .step-box:last-child {
        margin-right: 0;
      }
    }
  }
  //第三屏
  .home-page3 {
    height: 718px;
    width: 100%;
    background-color: #fafbff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 100px;
    .left {
      width: 495px;
      height: 495px;
      margin-left: 113px;
      position: relative;
      .circle {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        animation: circle 50s linear infinite;
      }
      .article {
        position: absolute;
        width: 350px;
        height: 575px;
        top: -52px;
        left: 64px;
        z-index: 2;
        box-shadow: 0px 3px 50px 1px rgba(137, 72, 255, 0.08);
      }
      .card {
        position: absolute;
        width: 288px;
        height: 161px;
        top: -24px;
        left: 240px;
        z-index: 3;
        animation: card 3s linear infinite;
      }
      .ball {
        position: absolute;
        width: 206px;
        height: 170px;
        top: 204px;
        left: 229px;
        z-index: 3;
        animation: spin 3s infinite linear;
        transform-origin: 50% 60%;
      }
      .search {
        width: 100%;
        animation: spin-reverse 3s infinite linear;
      }
    }
    .right {
      width: 441px;
      margin-right: 140px;

      .blod {
        font-size: 36px;
        color: #232323;
        margin-bottom: 60px;
        font-weight: bolder;
      }
      .tips {
        color: #232323;
        font-size: 14px;
        line-height: 40px;
      }
    }
  }
  //第四屏
  .home-page4 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 50px;
    .left {
      width: 441px;
      color: #232323;
      margin-left: 140px;
      flex-shrink: 0;
      .title {
        font-weight: bolder;
        font-size: 36px;
        margin-bottom: 50px;
      }
      .tips {
        font-size: 14px;
        line-height: 40px;
      }
    }
    .right {
      flex-shrink: 0;
      width: 572px;
      height: 480px;
      margin-right: 140px;
      animation: home4-down 3s linear infinite;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  //第五屏
  .home-page5 {
    width: 100%;
    margin-top: 100px;
    .title-box {
      width: 572px;
      height: 352px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      padding-top: 86px;
      box-sizing: border-box;
      .blod {
        text-align: center;
        font-size: 36px;
        font-weight: bolder;
      }
      .line-box {
        display: flex;
        justify-content: center;
        margin-top: 25px;
        .line-one {
          width: 49px;
          height: 8px;
          background: #8e54e9;
          border-radius: 5px 5px 5px 5px;
        }
        .line-tow {
          width: 14px;
          height: 8px;
          background: #8e54e9;
          border-radius: 5px 5px 5px 5px;
          margin-left: 5px;
        }
      }
      .tips {
        text-align: center;
        font-size: 16px;
        color: #000000;
        margin-top: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        .text-border {
          width: 35px;
          height: 10px;
          margin: 0 10px;
        }
      }
    }
    .number-boxs {
      display: flex;
      justify-content: space-around;
      .number-box {
        width: 250px;
        flex-shrink: 0;
        text-align: center;
        .number {
          font-size: 40px;
          font-weight: bolder;
        }
        .text {
          font-size: 16px;
          color: #000000;
          margin-top: 25px;
          font-weight: bolder;
        }
        .number1 {
          color: #ff6026;
        }
        .number2 {
          color: #8e54e9;
        }
        .number3 {
          color: #00baff;
        }
      }
    }
  }
  //页脚
  .footer-box {
    width: 100%;
    height: 780px;
    background-image: url("../assets/image/home/footer.png");
    background-size: cover;
    background-position: 100% 100%;
    background-repeat: no-repeat;
    margin-top: 110px;
    padding-top: 220px;
    box-sizing: border-box;
    .search-box {
      position: relative;
      width: 712px;
      height: 66px;
      background: #ffffff;
      border-radius: 6px 6px 6px 6px;
      left: 50%;
      transform: translateX(-50%);
      // top: 220px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .text-box {
        flex-shrink: 0;
        width: 400px;
        font-size: 18px;
        color: #232323;
        margin-left: 45px;
      }
      .btn-box {
        flex-shrink: 0;
        width: 129px;
        height: 38px;
        line-height: 38px;
        background: linear-gradient(141deg, #a270f0 0%, #8e54e9 100%);
        border-radius: 21px 21px 21px 21px;
        text-align: center;
        color: #fff;
        margin-right: 14px;
      }
    }
    .content-box {
      width: calc(100% - 280px);
      margin-left: 140px;
      margin-top: 60px;

      .icon-box {
        width: 145px;
        height: 50px;
        margin-bottom: 31px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .line {
        width: 100%;
        height: 1px;
        background: rgba(233, 236, 238, 0.3);
      }
      .info-boxs {
        display: flex;
        margin-top: 39px;
        justify-content: space-between;
        .info-box {
          .herder {
            color: #fff;
            font-size: 16px;
            display: flex;
            align-items: center;
            span {
              font-size: 14px;
            }
            img {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }
          }
          .tips {
            width: 200px;
            font-size: 14px;
            color: #fff;
            margin-top: 34px;
            line-height: 30px;
          }
          .item-box {
            display: flex;
            flex-direction: column;
            margin-top: 34px;
            .item {
              margin-bottom: 24px;
              color: #fff;
            }
            .item:last-child {
              margin-bottom: 0;
            }
          }
          .code-box {
            img {
              width: 82px;
              height: 82px;
              margin-top: 35px;
            }
            div {
              width: 82px;
              text-align: center;
              font-size: 14px;
              color: #fff;
            }
          }
        }
      }
    }
    .filing {
      text-align: center;
      color: #fff;
      margin-top: 40px;
      font-size: 14px;
    }
  }

  //页脚2
  .footer-box2 {
    width: 100%;
    height: 500px;
    background-image: url("../assets/image/home/footer2.png");
    background-size: cover;
    background-position: 0 0;
    background-repeat: no-repeat;
    margin-top: 100px;
    padding-top: 60px;
    box-sizing: border-box;
    display: none;
    .content-box {
      width: calc(100% - 28px);
      margin-left: 14px;
      margin-top: 60px;
      .icon-box {
        width: 101px;
        height: 34px;
        margin-bottom: 30px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .line {
        width: 100%;
        height: 1px;
        background: rgba(233, 236, 238, 0.3);
      }
      .info-boxs {
        display: flex;
        margin-top: 49px;
        flex-direction: column;
        .info-box {
          margin-bottom: 27px;
          .item-box {
            display: flex;
            justify-content: space-between;
            .item {
              color: #fff;
            }
            .item:last-child {
              margin-bottom: 0;
            }
            .herder {
              color: #fff;
              font-size: 16px;
              display: flex;
              align-items: center;
              span {
                font-size: 14px;
              }
              img {
                width: 20px;
                height: 20px;
                margin-right: 10px;
              }
            }
          }
        }
      }
    }
    .filing {
      text-align: center;
      font-size: 12px;
      color: #fff;
      line-height: 20px;
      margin-top: 30px;
    }
  }
}
</style>
<style>
@keyframes gold-down {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
@keyframes mail-ver {
  0%,
  100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(15deg);
  }
}
@keyframes paper-airplane {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(10px);
  }
}
@keyframes search {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
}

@keyframes light {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

@keyframes circle {
  0%,
  100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(360deg);
  }
}
@keyframes card {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}
@keyframes spin {
  to {
    transform: rotate(1turn);
  }
}
@keyframes spin-reverse {
  from {
    transform: rotate(1turn);
  }
}
@keyframes home4-down {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
</style>

<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1300px) {
  .home-main {
    // 第一屏
    .home-page1 {
      .left {
        margin-left: 70px;
      }
    }
    // 第三屏
    .home-page3 {
      .left {
        margin-left: 70px;
      }
      .right {
        margin-right: 70px;
      }
    }
    // 第四屏
    .home-page4 {
      .left {
        margin-left: 70px;
      }
      .right {
        margin-right: 70px;
      }
    }
    //页脚
    .footer-box {
      .content-box {
        width: calc(100% - 140px);
        margin-left: 70px;
        margin-top: 60px;
      }
    }
  }
}

/* 媒体查询 */
@media only screen and (max-width: 1200px) {
  .home-main {
    // 第一屏
    .home-page1 {
      .left {
        margin-left: 30px;
      }
    }
    // 第二屏
    .home-page2 {
      .title-box {
        height: 300px;
      }
      .step-boxs {
        flex-direction: column;
        align-items: center;
        .step-box {
          margin: 0;
          margin-bottom: 40px;
          .number::after {
            display: none;
          }
        }
      }
    }

    // 第三屏
    .home-page3 {
      .left {
        margin-left: 30px;
      }
      .right {
        margin-right: 30px;
      }
    }
    // 第四屏
    .home-page4 {
      .left {
        margin-left: 30px;
      }
      .right {
        margin-right: 30px;
      }
    }
    //页脚
    .footer-box {
      .content-box {
        width: calc(100% - 60px);
        margin-left: 30px;
        margin-top: 60px;
      }
    }
  }
}

/* 媒体查询 */
@media only screen and (max-width: 1100px) {
  .home-main {
    // 第一屏
    .home-page1 {
      display: flex;
      justify-content: center;
      .left {
        margin-left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 10px;
        box-sizing: border-box;
        .tips {
          text-align: center;
        }
      }
      .right {
        display: none;
      }
    }
    //第三屏
    .home-page3 {
      min-height: 960px;
      height: auto;
      display: block;
      position: relative;
      margin-top: 40px;
      .right {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
      }
      .left {
        top: 400px;
        left: 50%;
        transform: translateX(-50%);
        margin-left: 0;
      }
    }
    //第四屏
    .home-page4 {
      flex-direction: column;
      .left {
        margin: 0;
        text-align: center;
      }
      .right {
        margin: 0;
        margin-top: 50px;
      }
    }
    //第五屏
    .home-page5 {
      .title-box {
        max-width: 400px;
        height: 300px;
        padding: 0 10px;
        box-sizing: border-box;
      }
      .number-boxs {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .number-box {
          margin-bottom: 42px;
        }
      }
    }
  }
}
/* 媒体查询 */
@media only screen and (max-width: 1000px) {
  .home-main {
    .home-page1 {
      min-height: 700px;
    }
    //页脚
    .footer-box {
      display: none;
      margin-top: 40px;
    }
    .footer-box2 {
      display: block;
      margin-top: 40px;
    }
  }
}

/* 媒体查询 */
@media only screen and (max-width: 800px) {
  .home-main {
    //第三屏
    .home-page3 {
      min-height: 750px;
      .left {
        width: 300px;
        height: 300px;
        top: 400px;
        .article {
          position: absolute;
          width: 210px;
          height: 345px;
          top: -31px;
          left: 36px;
          z-index: 2;
          box-shadow: 0px 2px 30px 1px rgba(137, 72, 255, 0.08);
        }
        .card {
          position: absolute;
          width: 172px;
          height: 94px;
          top: -14px;
          left: 144px;
          z-index: 3;
          animation: card 3s linear infinite;
        }
        .ball {
          position: absolute;
          width: 103px;
          height: 102px;
          top: 122px;
          left: 137px;
          z-index: 3;
          animation: spin 3s infinite linear;
          transform-origin: 50% 60%;
        }
        .search {
          width: 100%;
          animation: spin-reverse 3s infinite linear;
        }
      }
      .right {
        padding: 0 10px;
        box-sizing: border-box;
      }
    }
    //第四屏
    .home-page4 {
      flex-direction: column;
      .left {
        width: 400px;
        padding: 0 10px;
        box-sizing: border-box;
      }
      .right {
        width: 375px;
        height: 314px;
      }
    }
  }
}

/* 媒体查询 */
@media only screen and (max-width: 600px) {
  .home-main {
    // 第二屏
    .home-page2 {
      .title-box {
        max-width: 100%;
      }
    }
  }
}
</style>